import { call, put, takeEvery, select } from "redux-saga/effects"
import {
  getAllBusinessAction,
  getAllBusinessActionSuccess,
  updateBusinessAction,
  updateBusinessActionSuccess,
  patchBusinessGoveranceRightsSuccess,
  getAppSettingsActionSuccess,
} from "./actions"

import {
  GET_BUSINESS,
  ADD_BUSINESS,
  UPDATE_BUSINESS_ACCESS,
  PATCH_BUSINESS_GOVERNANCE_RIGHTS,
  PATCH_BUSINESS_AS_ADMIN_ACTION,
  PATCH_USER_ACTIVATION,
  ADMIN_PATCH_BUSINESS_ROLE,
  ADMIN_DELETE_BUSINESS_ROLE,
  GET_APP_SETTINGS,
} from "Containers/ConsoleAdminContainer/constants"

import {
  responseTypeIsError,
  responseTypeIsSuccess,
  manageErrorGenerator,
  manageSuccessGenerator,
} from "Containers/App/saga"

import { selectCurrentToken } from "Containers/Login/selectors"

import { config } from "Utils/config"
import request from "Utils/request"
import { postCors, getCors, patchCors, deleteCors } from "Utils/rulesCors"
import { setErrorMessage } from "Containers/Messages/actions"

function* getAllBusiness() {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }

  const { API_URL } = config
  const requestURL = `${API_URL}/business`

  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (response?.body) {
        yield put(getAllBusinessActionSuccess(response.body))
      }
    }
  } catch (err) {
    var routeCalled = "[route] => /business => ERROR => "
    console.error(routeCalled, err)
    yield put(setErrorMessage(err))
  }
}

function* addNewBusiness({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }

  const { API_URL } = config
  const requestURL = `${API_URL}/business`

  var requestBody = { ...payload }

  try {
    const response = yield call(request, requestURL, postCors(requestBody, specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
        yield put(getAllBusinessAction())
      }
    }
  } catch (err) {
    var routeCalled = "[route] => /business => ERROR => "
    console.error(routeCalled, err)
    yield call(manageErrorGenerator, { err, showMessageToUser: true })
  }
}

function* patchBusinessGovernanceSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }

  const { API_URL } = config

  const requestURL = `${API_URL}/changeGovernanceRight`

  var requestBody = { ...payload }

  try {
    const response = yield call(request, requestURL, patchCors(requestBody, specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else if (responseTypeIsSuccess(response)) {
      yield call(manageSuccessGenerator, { response, showMessageToUser: true })
      yield put(getAllBusinessAction())
    }
  } catch (err) {
    var routeCalled = "[route] => PATCH /changeGovernanceRight => ERROR => "
    console.error(routeCalled, err)
    yield put(setErrorMessage(err))
  }
}

function* patchBusinessAsAdminSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }

  const { API_URL } = config
  const requestURL = `${API_URL}/v2/updateBusiness`
  var requestBody = { ...payload }

  try {
    const response = yield call(request, requestURL, patchCors(requestBody, specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else if (responseTypeIsSuccess(response)) {
      yield call(manageSuccessGenerator, { response, showMessageToUser: true })
      yield put(getAllBusinessAction())
    }
  } catch (err) {
    var routeCalled = "[route] => PATCH /v2/updateBusiness => ERROR => "
    console.error(routeCalled, err)
    yield put(setErrorMessage(err))
  }
}

function* patchUserActivation({ payload }) {
  const token = yield select(selectCurrentToken)

  const { API_URL } = config
  const requestURL = `${API_URL}/user/updateActivation`
  try {
    const response = yield call(request, requestURL, patchCors(payload, { token }))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else if (responseTypeIsSuccess(response)) {
      yield call(manageSuccessGenerator, { response, showMessageToUser: true })
      yield put(getAllBusinessAction())
    }
  } catch (err) {
    var routeCalled = "[route] => PATCH /user/updateActivation => ERROR => "
    console.error(routeCalled, err)
    yield put(setErrorMessage(err))
  }
}

function* updateBusinessRole({ payload }) {
  const token = yield select(selectCurrentToken)
  const { role, businessId } = payload

  const specificHeaders = { token: token }

  const { API_URL } = config
  const requestURL = `${API_URL}/businessRoles/${businessId}/${role?.accessId}`
  try {
    const response = yield call(request, requestURL, patchCors(role, specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
    }
  } catch (err) {
    console.error("[route] --> /businessRoles/:businessId/:roleId | PATCH | ERROR |", err)
    yield put(setErrorMessage(err))
  }
}

function* deleteBusinessRole({ payload }) {
  const token = yield select(selectCurrentToken)
  const { roleId, businessId } = payload

  const specificHeaders = { token: token }

  const { API_URL } = config
  const requestURL = `${API_URL}/businessRoles/${businessId}/${roleId}`
  try {
    const response = yield call(request, requestURL, deleteCors(specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
      }
    }
  } catch (err) {
    console.error("[route] --> /businessRoles/:businessId/:roleId | DELETE | ERROR |", err)
    yield put(setErrorMessage(err))
  }
}

function* getAppSettings() {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }

  const { API_URL } = config
  const requestURL = `${API_URL}/appSettings`

  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: false })
    } else {
      if (response) {
        yield put(getAppSettingsActionSuccess(response))
      }
    }
  } catch (err) {
    var routeCalled = "[route] => /business => ERROR => "
    console.error(routeCalled, err)
    yield put(setErrorMessage(err))
  }
}

function* adminConsoleSaga() {
  yield takeEvery(GET_BUSINESS, getAllBusiness)
  yield takeEvery(ADD_BUSINESS, addNewBusiness)
  yield takeEvery(PATCH_BUSINESS_GOVERNANCE_RIGHTS, patchBusinessGovernanceSaga)
  yield takeEvery(PATCH_BUSINESS_AS_ADMIN_ACTION, patchBusinessAsAdminSaga)
  yield takeEvery(PATCH_USER_ACTIVATION, patchUserActivation)
  yield takeEvery(ADMIN_PATCH_BUSINESS_ROLE, updateBusinessRole)
  yield takeEvery(ADMIN_DELETE_BUSINESS_ROLE, deleteBusinessRole)
  yield takeEvery(GET_APP_SETTINGS, getAppSettings)
}

export default adminConsoleSaga
